import 'keen-slider/keen-slider.min.css'
import Image from 'next/image'
import {getStrapiMedia} from "@utils/strapi";
import delve from "dlv";
import {useState} from "react";
import {useKeenSlider} from "keen-slider/react";

const ImageSlider = ({id, Images}: any) => {

  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)
  const [sliderRef, instanceRef] = useKeenSlider({
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    },
    renderMode: 'performance',
    slides: {perView: 1, spacing: 15},
  })

    return (
    <div className="pb-4 md:my-4">
      <div className="relative full-slider">
        <div className="my-4">
          <div className="">
            <div ref={sliderRef} className="keen-slider">
              {Images.data.map((item: any, i: any) => {
                return (
                  <div key={i} className="keen-slider__slide">
                    <div className="relative line-height-1" key={i}>
                      <Image
                        className="object-cover line-height-1"
                        src={getStrapiMedia(delve(item, 'attributes.url')) || ""}
                        alt={delve(item, 'attributes.alternativeText') || ""}
                        width={1600}
                        height={900}
                        priority={i === 0}
                        quality="85"
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          {loaded && instanceRef.current && (
            <>
              <Arrow
                left
                onClick={(e: { stopPropagation: () => any; }) =>
                  e.stopPropagation() || instanceRef.current?.prev()
                }
                disabled={currentSlide === 0}
              />

              <Arrow
                onClick={(e: { stopPropagation: () => any; }) =>
                  e.stopPropagation() || instanceRef.current?.next()
                }
                disabled={
                  currentSlide ===
                  instanceRef.current.track.details.slides.length - 1 /* todo: here it should access the perview breakpoint value instead of overall length or it will never reach last slide to be disabled */
                }
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

function Arrow(props: any) {
  const disabled = props.disabled ? " arrow--disabled" : ""
  return (
    <svg
      onClick={props.onClick}
      className={`arrow ${
        props.left ? "arrow--left" : "arrow--right"
      } ${disabled}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      {props.left && (
        <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/>
      )}
      {!props.left && (
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/>
      )}
    </svg>
  )
}

ImageSlider.defaultProps = {};
export default ImageSlider;
